module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_19_4.1293aa3c.jpeg";